module.exports = __webpack_public_path__ + "img/Cloud.ad4cbeb1.svg";